export const MEMORY_PROMPT_MAX_LENGTH = 10000;
export const MEMORY_PROMPT_MIN_LENGTH = 20;
export const MAX_MEMORIES_PER_SMART_ASSISTANT = 20;
